import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import {
  FormSignUpStep13,
  Header,
  Footer,
  StepBubbles,
  ModalEmailSignUp,
} from "~/components/blocks";
import { Margin, Title, Text, Breadcrumb, Alert } from "~/components/elements";
import { HeroBanner } from "~/components/sections";
import { Grid } from "@material-ui/core";
import * as S from "./styles";
import { scrollTo } from "~/utils/tools";
import isMobile from "~/hooks/isMobile";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";
import {redirectSignUpFlow} from "~/pages/helper";
import { Creators as AccountActions } from "~/store/modules/account/actions";

export default function SignUpStep13() {
  const mobile = isMobile();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const personalData = useSelector(
        (state) => state.account.details.dadosPessoais
      );
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Complemente seu cadastro",
      link: "/cadastre-se/passo-1/bebe",
    },
  ];

  const [openModalVerifyEmail, setOpenModalVerifyEmail] = useState(false);
  const verifyEmail = useSelector((state) => state.signUp.verifyEmail);
  useEffect(() => {
    if (verifyEmail.success) {
      setOpenModalVerifyEmail(true);
    }
    redirectSignUpFlow(personalData?.DocumentoCrip, personalData?.Filhos, personalData?.Instagram, history, location, personalData?.cupons)
  }, [verifyEmail, personalData, location, history]);

  useEffect(() => {
    dispatch(AccountActions.getUserDetails());
  }, [dispatch]);

  useEffect(() => {
    scrollTo(700);
  }, []);

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Complemente seu cadastro</title>
      </Helmet>
      <Header />
      <HeroBanner />
      <Breadcrumb navBreadcrumb={navBreadcrumb} />
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <S.BG>
          <Grid container justifyContent="center">
            <Margin mt={mobile ? 12 : 9} mb={8}>
              <S.TitleHolder>
                <Title as="5" levelDesktop="5" level="1">
                  <strong>Complete os dados do seu bebê</strong>
                </Title>
                <S.TextWrapper>
                  <Margin pt={mobile ? 6 : 3} mb={1}>
                    <Text level="2">
                      <Text as="strong" level="2">
                        Faça seu cadastro para registrar suas notas fiscais para concorrer aos prêmios instantâneos e ao concurso.<br/>
                      </Text>
                      Ao preencher seus dados, você concorda com o{" "}
                      <Link to={`/regulamento#conteudo${location.search}`}>
                        regulamento da promoção
                      </Link>{" "}
                      e afirma estar ciente de que toda informação enviada está
                      sujeita à{" "}
                      <a
                        href="https://www.johnsonsbaby.com.br/politica-de-privacidade"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Política de Privacidade.
                      </a>
                    </Text>
                  </Margin>
                </S.TextWrapper>

                <S.AlertWrapper>
                  <Alert type="warning">
                    Os dados pessoais que você fornecer voluntariamente serão usados para fazer o seu registro neste site e na promoção Bebê Johnson’s. As informações serão utilizadas somente, se necessário, para o processo de entrega de premiação, conforme descrito no regulamento.
                  </Alert>
                </S.AlertWrapper>

                <Margin>
                  <StepBubbles step={1} mobile={mobile} />
                </Margin>
              </S.TitleHolder>
              <FormSignUpStep13 />
            </Margin>
          </Grid>
        </S.BG>
      </motion.div>
      <ModalEmailSignUp
        open={openModalVerifyEmail}
        close={setOpenModalVerifyEmail}
      />
      <Footer />
    </>
  );
}
